import axios from "axios";
import API_BASE_URL from "../config";

const Category_API  = `${API_BASE_URL}/categories`; // Backend API URL

 // ✅ Get Authenticated User
 export const getAuthToken = () => {
    return localStorage.getItem("token"); // ✅ Fetch Token from Storage
  };
  
    // ✅ Get Authenticated User
    export const getuserId = () => {
      return localStorage.getItem("userId"); // ✅ Fetch userid from Storage
    };

export const getAllCategories = async () => {
  try {
    const response = await axios.get(`${Category_API}/getall`, ); // Using POST for consistency
    return response.data; // ✅ Return API response
  } catch (error) {
    console.error("Get Categories Error:", error);
    return { success: false, categories: [] }; // ✅ Return empty array on error
  }
};
